<template>
  <div
    class="ws-text-chip"
    :class="[{red:red,thin:thin,gray:gray,small:small,big:big,yellow:yellow,blue:blue,green:green,'has-bg':hasBg},color]"
  >
    <i
      v-if="leadingIcon"
      class="leading-icon"
      :class="[leadingIcon,{iconLg:iconLg,iconMd:iconMd,iconSm:iconSm,iconXl:iconXl,iconXs:iconXs}]"
    />
    <img
      v-if="leadingImg"
      :src="leadingImg"
      alt=""
      class="ws-text-chip__img"
    >
    <p
      class="ws-text-chip_text mt-0"
      :class="{fontSizeLg:fontSizeLg,fontSizeMd:fontSizeMd,fontSizeSm:fontSizeSm,fontSizeXl:fontSizeXl,fontSizeXs:fontSizeXs,'dark':isDarkText}"
    >
      {{ $t(textLabel) }}<span v-if="num">{{ num }}</span><span
        v-if="hasPercent"
        class="ws-text-chip_text-percent"
      >%</span>
    </p>
  </div>
</template>
<script>
export default {
  name: "WsTextChip001",
  props: {
    leadingImg: {
      type: String,
      default: "",
    },
    hasBg: {
      type: Boolean,
      default: false,
    },
    leadingIcon: {
      type: String,
      default: "",
    },
    textLabel: {
      type: String,
      default: "",
    },
    red: {
      type: Boolean,
      default: false,
    },
    thin: {
      type: Boolean,
      default: false,
    },
    icon24: {
      type: Boolean,
      default: false,
    },
    num: {
      type: Number,
      default: 0,
    },
    gray: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: false,
    },
    big: {
      type: Boolean,
      default: false,
    },
    yellow: {
      type: Boolean,
      default: false,
    },
    blue: {
      type: Boolean,
      default: false,
    },
    iconSize: {
      type: Number,
      default: 1.125,
    },
    fontSize: {
      type: Number,
      default: 1,
    },
    green: {
      type: Boolean,
      default: false,
    },
    iconXl: {
      type: Boolean,
      default: false,
    },
    iconLg: {
      type: Boolean,
      default: false,
    },
    iconMd: {
      type: Boolean,
      default: false,
    },
    iconSm: {
      type: Boolean,
      default: false,
    },
    iconXs: {
      type: Boolean,
      default: false,
    },
    fontSizeLg: {
      type: Boolean,
      default: false,
    },
    fontSizeXs: {
      type: Boolean,
      default: false,
    },
    fontSizeSm: {
      type: Boolean,
      default: false,
    },
    fontSizeMd: {
      type: Boolean,
      default: false,
    },
    fontSizeXl: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: "",
    },
    hasPercent: {
      type: Boolean,
      default: false,
    },
    isDarkText: {
      type: Boolean,
      default: false,
    },
  },
};
</script>